import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';
import { useErrorContext } from '@qpr/client-library';
import React from 'react';
import useNavitems from '../../../api/useNavitems';
import HorizontalMenu from './HorizontalMenu';

const PREFIX = 'HorizontalMenuView';

const classes = {
  iconDiv: `${PREFIX}-iconDiv`
};

const StyledHorizontalMenu = styled(HorizontalMenu)(() => ({
  [`& .${classes.iconDiv}`]: {
    height: '48px',
    width: '48px'
  }
}));

interface HorizontalMenuViewProps {
  tenant: string;
}

const HorizontalMenuView = ({ tenant }: HorizontalMenuViewProps) => {
  const { setError } = useErrorContext();

  const { isLoading, error, data } = useNavitems();

  if (error && error.response) setError(error.response.data);

  const menuItems = data?.data.children ? data.data.children : [];

  return isLoading === true ? (
    <div className={classes.iconDiv}>
      <CircularProgress color="inherit" />
    </div>
  ) : (
    <StyledHorizontalMenu menuItems={menuItems} tenant={tenant} />
  );
};

export default HorizontalMenuView;
